<template>
  <li
    :data-qa="`replacement-item-${original.listingId}-${replacement.listingId}`"
  >
    <div class="flex flex-col justify-between gap-16 md:flex-row">
      <div class="flex gap-12 lg:gap-24">
        <ProductIllustration
          class="size-60 md:size-[110px]"
          :image="replacement.image"
          :title="replacement.title"
        />
        <div class="grow">
          <Description
            :category-id
            :grade-id="replacement.grade.value"
            :grade-name="replacement.grade.name"
            :is-out-of-stock="false"
            :sim-type="replacement.dualSim"
            :special-offer-type="replacement.offerType.value"
            :title="replacement.title"
          />

          <ReplacementDescription
            :category-id
            class="mt-12 hidden md:block"
            :mobile-plan
            :original
            :replacement
          />
        </div>
      </div>

      <div class="flex flex-col items-start gap-16 md:items-end">
        <ReplacementDescription
          :category-id
          class="block md:hidden"
          :mobile-plan
          :original
          :replacement
        />

        <span
          class="heading-2"
          :class="priceColorToken"
          data-qa="replacement-price"
        >
          {{ i18n.price(replacement.price) }}
        </span>

        <RevButton
          data-qa="replacement-button"
          full-width="adaptive"
          :loading
          variant="primary"
          @click="emit('replace')"
        >
          {{ i18n(translations.chooseReplacement) }}
        </RevButton>
      </div>
    </div>

    <div v-if="mobilePlan?.selectedOffer" class="mt-16 w-full">
      <div class="bg-static-default-mid rounded-sm flex items-center gap-6 p-8">
        <IconPlus />
        <MobilePlanPartnerLogo
          :height="20"
          :logo="mobilePlan.selectedOffer.partner.logo"
        />
        {{ mobilePlan.selectedOffer.label }}
      </div>
    </div>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import type { ReplacementOption } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import MobilePlanPartnerLogo from '@backmarket/nuxt-layer-checkout/components/MobilePlanPartnerLogo/MobilePlanPartnerLogo.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { tw } from '@backmarket/utils/string/tw'
import { RevButton } from '@ds/components/Button'
import { IconPlus } from '@ds/icons/IconPlus'

import Description from '../../../Product/components/Description/Description.vue'
import ProductIllustration from '../../../Product/components/ProductIllustration/ProductIllustration.vue'
import ReplacementDescription from '../ReplacementDescription/ReplacementDescription.vue'

import translations from './ReplacementItem.translations'

const props = defineProps<{
  original: ReplacementOption
  replacement: ReplacementOption
  categoryId: number
  mobilePlan?: { selectedOffer: MobilePlanOffer } | null
  loading: boolean
}>()

const emit = defineEmits(['replace'])

const i18n = useI18n()

const priceColorToken = computed(() => {
  const newPrice = parseInt(props.replacement.price.amount, 10)

  if (parseInt(props.original.price.amount, 10) < newPrice) {
    return tw`text-static-brand-hi`
  }
  if (parseInt(props.original.price.amount, 10) > newPrice) {
    return tw`text-static-success-hi`
  }

  return tw`text-static-default-hi`
})
</script>
